var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensitiveOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67095 7.78008L1.56324 8L1.67095 8.21992C2.25094 9.40414 3.15153 10.4019 4.27036 11.0997C5.38919 11.7976 6.68137 12.1675 7.99999 12.1675C9.31861 12.1675 10.6108 11.7976 11.7296 11.0997C12.8484 10.4019 13.749 9.40414 14.329 8.21992L14.4367 8L14.329 7.78008C13.749 6.59585 12.8484 5.59811 11.7296 4.90026C10.6108 4.20241 9.31861 3.83245 7.99999 3.83245C6.68137 3.83245 5.38919 4.20241 4.27036 4.90026C3.15153 5.59811 2.25094 6.59585 1.67095 7.78008ZM7.99999 6.5C8.39782 6.5 8.77935 6.65804 9.06065 6.93934L9.4142 6.58579L9.06065 6.93934C9.34196 7.22064 9.49999 7.60218 9.49999 8C9.49999 8.39783 9.34196 8.77936 9.06065 9.06066C8.77935 9.34196 8.39782 9.5 7.99999 9.5C7.60217 9.5 7.22063 9.34196 6.93933 9.06066C6.65803 8.77936 6.49999 8.39783 6.49999 8C6.49999 7.60218 6.65803 7.22064 6.93933 6.93934C7.22063 6.65804 7.60217 6.5 7.99999 6.5ZM7.99999 3.5C11.0503 3.5 13.6674 5.35446 14.793 8C13.6674 10.6455 11.0503 12.5 7.99999 12.5C4.94966 12.5 2.33257 10.6455 1.20694 8C2.33257 5.35446 4.94966 3.5 7.99999 3.5Z",
    fill: "#333333",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensitiveOn);
export default __webpack_public_path__ + "static/media/sensitive-on.52395bd97e991c77cb631141d04c6aa9.svg";
export { ForwardRef as ReactComponent };